// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"db0c41e0","242":"31949ee8","287":"51ead04b","567":"eed460fe","878":"01cbbbf1","925":"10cd18a0"}[chunkId] + ".chunk.js";
};